import RandRDashboardTable from './RandRDashboardTable';

export default RandRDashboardTable;
